import { ROUTES } from '@/lib/routes';

export const SidebarConfig = {
  [ROUTES.ADMIN]: {
    icon: '/icons/logo_panel.svg',
    links: [
      {
        icon: '/icons/server.svg',
        name: 'Users',
        path: ROUTES.ADMIN_USERS,
        disabled: false,
      },
      {
        name: 'Coaches',
        path: ROUTES.ADMIN_COACHES,
        icon: '/icons/speakerphone.svg',
        disabled: true,
      },
      { name: 'Sessions', path: ROUTES.ADMIN_SESSIONS, icon: '/icons/camera.svg', disabled: false },
    ],
  },
  [ROUTES.PREVIEWER]: {
    icon: '/icons/logo_content.svg',
    links: [{ name: 'Previewer', path: ROUTES.PREVIEWER, disabled: false }],
  },
  [ROUTES.TARIFFS]: {
    icon: '/icons/logo_plans.svg',
    links: [{ name: 'Tariffs', path: ROUTES.TARIFFS, disabled: false }],
  },
  [ROUTES.COACH]: {
    icon: '/icons/logo.svg',
    links: [
      {
        name: 'Sessions',
        path: ROUTES.COACH,
        disabled: false,
      },
      {
        name: 'Schedule',
        path: ROUTES.COACH_SCHEDULE,
        disabled: false,
      },
      {
        name: 'Calendar',
        path: ROUTES.COACH_CALENDAR,
        disabled: false,
      },
    ],
  },
};
